// vim: set ts=2 sts=2 sw=2 et:
//
// redux-persist se traga los errores al guardar en el navegador: en el Ibero 2026 el torneo dejó de
// guardarse sin que nadie se enterara, y una recarga dejó OpenLifter vacío. Esto registra la falla para que
// la pantalla la muestre (PersistFailureBanner).

type Listener = (failing: boolean) => void;

let failing = false;
const listeners = new Set<Listener>();

export const reportPersistFailure = (): void => {
  if (failing) return;
  failing = true;
  listeners.forEach((listener) => listener(true));
};

export const isPersistFailing = (): boolean => failing;

export const subscribePersistHealth = (listener: Listener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/** Solo para tests. */
export const resetPersistHealthForTests = (): void => {
  failing = false;
};
